/* global axios */
import ApiClient from './ApiClient';

class PromotionalCampaignsAPI extends ApiClient {
  constructor() {
    super('promotional_campaigns', { accountScoped: false });
  }

  logEvent(campaignId, { eventType, durationSeconds }) {
    return axios.post(`${this.url}/${campaignId}/events`, {
      event: { event_type: eventType, duration_seconds: durationSeconds },
    });
  }
}

export default new PromotionalCampaignsAPI();
